import { useEffect, useState } from 'react';

import { useFullStory } from '@goshippo/utilities';

import { useSelector } from 'react-redux';

import { getUser } from '~/selectors/user.selectors';
import { getFullName } from '~/types/User';
import { trackingHelper } from '~/utils/TrackingHelper';
import { getCookie } from '~/utils/cookies';

import { newRelic } from '../newRelic/newRelic';
import { useFullStoryUserVars } from './hooks/useFullStoryUserVars/useFullStoryUserVars';

/**
 * Watches for changes to user information and if available,
 * calls FullStory identify with user info
 */
const FullStoryMonitor = () => {
  const { event: fullStoryEvent, getCurrentSessionURL, identify, isInitialized } = useFullStory();

  const [fsIdentifyCalled, setFsIdentifyCalled] = useState<boolean>(false);

  const user = useSelector(getUser);

  const isFsInitialized = isInitialized();
  const isImpersonatingCookie = getCookie('is_impersonate') || '';
  const isImpersonating = isImpersonatingCookie.toLowerCase() === 'true';
  const sessionURL = isFsInitialized ? getCurrentSessionURL() : null;

  useFullStoryUserVars();

  // Identify user in FullStory once initialized
  useEffect(() => {
    if (user && isFsInitialized && !fsIdentifyCalled && !isImpersonating) {
      identify(String(user.id), {
        dateJoined_date: user.dateJoined.toISOString(),
        displayName: getFullName(user),
        email: user.email,
        orders_experience: 'new',
        release: APP_VERSION,
      });
      setFsIdentifyCalled(true);
    }
  }, [user, isFsInitialized, fsIdentifyCalled, identify, isImpersonating]);

  useEffect(() => {
    if (!isFsInitialized) return;
    trackingHelper.fullStoryEvent = fullStoryEvent;
  }, [isFsInitialized, fullStoryEvent]);

  // Send FullStory session URL to New Relic
  useEffect(() => {
    if (!sessionURL) return;

    newRelic.setCustomAttribute(
      'fullStorySessionURL',
      sessionURL.replace(CONFIG.fullStory.host || '', 'fullstory.com'),
    );
  }, [sessionURL]);

  useEffect(() => {
    if (!user) setFsIdentifyCalled(false);
  }, [user]);

  return null;
};

export default FullStoryMonitor;
